import React from "react";
import { TsSchema } from "../data/schema";
import { useNavigate } from "react-router-dom";
import { Button } from "src/shadcn/components/ui";
type Props = {
  row: TsSchema;
};
const Actions = ({ row }: Props) => {
  const navigate = useNavigate();
  return (
    <div>
      <Button
        variant={"outline"}
        onClick={() => navigate("/" + "report/view/tsc/" + row._id)}
        disabled={row?.status !== "completed"}
      >
        View
      </Button>
    </div>
  );
};

export default Actions;
